import { useEffect } from "react"

import { useReferralFTUXModalStore } from "./ReferralFTUXModal"
import { useDownloadMobileAppModal } from "../../../components/modals/DownloadMobileAppModal"
import { localStorageItems } from "../../../util/storage"

export const useShowReferralFTUXModal = () => {
  const { isOpen: isOpenReferralFTUXModal, onOpen: onOpenReferralFTUXModal } =
    useReferralFTUXModalStore()
  const { isOpen: isOpenDownloadMobileAppModal } = useDownloadMobileAppModal()

  useEffect(() => {
    const hasSeenReferralFTUXModal = localStorage.getItem(
      localStorageItems.hasSeenReferralFTUXModal
    )
    if (
      !hasSeenReferralFTUXModal &&
      !isOpenReferralFTUXModal &&
      !isOpenDownloadMobileAppModal
    ) {
      onOpenReferralFTUXModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenDownloadMobileAppModal])
}
